import { Component, Input } from '@angular/core';
import { Promotion, PromotionCardType } from '../../../models/promotion';

@Component({
    selector: 'app-campaign',
    templateUrl: './campaign.component.html',
    styleUrls: ['./campaign.component.scss'],
})
export class CampaignComponent {
    @Input() campaign: Promotion;
    PromotionCardType = PromotionCardType;
}
